import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import '@/assets/styles/reset.scss'
import { Notify, Dialog } from 'vant'
import vueTouch from "vue-plugin-touch"
import touch from 'vue-directive-touch'
import VueI18n from 'vue-i18n'
import 'lib-flexible'
import 'vant/lib/index.css';
Vue.use(Notify).use(Dialog).use(vueTouch).use(touch).use(VueI18n);

localStorage.removeItem('lang');

const i18n = new VueI18n({
    locale: 'zh_cn',
    messages: {
      zh_cn: require('./assets/languages/zh_CN.json')
    }
});
Vue.config.productionTip = false;

window.vm = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
